import tokens from '@nimbus-ds/tokens/dist/js/tokens';
import { StylesConfig } from 'react-select';
import {
  OptionType,
  multiSelectColourStyles,
} from '../MultiSelect/multiSelectStyleConfig';

export const searchMultiSelectStyles: StylesConfig<OptionType, true> = {
  ...multiSelectColourStyles,
  control: (base, state) => ({
    ...multiSelectColourStyles.control?.(base, state),
    borderColor: state.isFocused
      ? '#0059d5'
      : tokens.color.light.neutral[80].value,
    boxShadow: state.isFocused
      ? '0 0 0 3px #96c1fc'
      : multiSelectColourStyles.control?.(base, state)?.boxShadow ?? 'none',
    cursor: 'text',
  }),
  clearIndicator: (styles) => ({
    ...styles,
    padding: '6px',
    cursor: 'pointer',
  }),
};
